<!-- <mat-toolbar class="topbar"> -->
<div class="topbar" fxLayout="column" fxLayoutGap="10px">
    <div class="topbar-inner" fxLayout="column" fxLayoutGap="10px">
        <div fxLayoutAlign="space-between">
            <div fxLayoutAlign="center center" fxLayoutGap="10px">
                <a routerLink="/" fragment="top" fxLayoutAlign="center center" fxLayoutGap="10px" class="no-underline"><img id="logo_small" src="assets/images/logo.svg">
                <span style="font-size: 24px; color: #4a148c">look@menu</span></a>
            </div>
            <div fxLayoutGap="20px" fxLayoutGap.xs="10px">
                <app-scan-qrcode></app-scan-qrcode>
                <button mat-flat-button color="primary" routerLink="/login" i18n>Zaloguj</button>
            </div>
        </div>
        <mat-divider></mat-divider>
    </div>
</div>

<!-- </mat-toolbar> -->
<div id="top" class="wrapper">
    <div fxLayout="column" fxLayoutGap="50px">
        <!-- <div class="topbar" fxLayout="column" fxLayoutGap="10px">
            <div fxLayoutAlign="space-between">
                <div fxLayoutAlign="center center" fxLayoutGap="10px">
                    <img id="logo_small" src="assets/images/logo.svg">
                    <span style="font-size: 24px; color: #4a148c">look@menu</span>
                </div>
                <div fxLayoutGap="20px" fxLayoutGap.xs="10px">
                    <app-scan-qrcode></app-scan-qrcode>
                    <button mat-flat-button color="primary" routerLink="/login">Zaloguj</button>
                </div>
            </div>
            <mat-divider></mat-divider>
        </div> -->
        <!-- <div class="top-bar">
            <h1>look@menu</h1>
        </div> -->
        <div id="content">
            <router-outlet></router-outlet>
        </div>
        <div id="footer" fxLayout.gt-xs="row" fxLayout.lt-sm="column" fxLayoutAlign="space-between">
            <div id="footer-menu" fxLayout="column">
                <a routerLink="terms-and-conditions" fragment="top" class="no-underline">Regulamin</a>
                <a routerLink="privacy-policy" fragment="top" class="no-underline">Polityka prywatności</a>
            </div>
        
            <div>
                Właścicielem serwisu jest <strong>look@menu Wojciech Adamski, Mateusz Brychcy S.C.</strong><br />
                Ul. Obornicka 330, 60-689 Poznań<br />
                Tel. 61 62 43 440<br />
                E-mail: biuro@lookat.menu<br />
                NIP: 9721319386
            </div>
        </div>
    </div>
</div>